import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { PDFOptions } from './pdf-viewer/pdf-options';
import { rlPdfViewerComponent } from './pdf-viewer/rl-pdf-viewer.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { Annotation } from '../annotations/shared/annotation';
import { AnnotatorContainerDirective } from '../annotations/shared/annotator-container.directive';
import { RlFile } from '../rl-common/file/shared/rl-file';
import { FileService } from '../rl-common/file/core/file.service';
import { Visibility } from '../rl-common/shared/shared/types/visibility.enum';
import { AnnotationConfig } from '../annotations/shared/annotation-config';
import { AnnotatorConfig } from '../annotations/shared/annotator-config';
import { ToolbarOptionsConfig } from './toolbar/toolbar-options-config';
import { AuthService, ContainerService } from '../ajs-upgraded-providers';
import { UtilsService } from '../rl-common/shared/core/utils.service';
import { AnnotationsStorageService } from '../annotations/core/annotations-storage.service';
import { skip } from 'rxjs/operators';
import { EntityType } from '../rl-common/shared/shared/entity-type.enum';

@Component({
  selector: 'rl-embedded-view',
  templateUrl : './embedded-view.component.html',
  styleUrls: ['./embedded-view.component.scss', './embedded-view.component-rtl.css']
})
export class EmbeddedViewComponent implements OnInit{

  @Input() file : RlFile;
  @Input() annotatorConfig : AnnotatorConfig = new AnnotatorConfig();
  @Input() toolbarConfig? : ToolbarOptionsConfig = new ToolbarOptionsConfig();

  @ViewChild(ToolbarComponent) toolbar : ToolbarComponent;
  @ViewChild(rlPdfViewerComponent) pdfViewerComp : rlPdfViewerComponent;
  @ViewChild(AnnotatorContainerDirective) annotator : AnnotatorContainerDirective;

  busy : boolean = true;
  config : PDFOptions = new PDFOptions();
  openCommentPanel : boolean = false;
  hideFileAnnotations : boolean = false;
  showAnnotations : boolean = true;
  tabScanner = false;
  isGuest: boolean;

  constructor(private fileService : FileService, private containerService : ContainerService, private authService : AuthService, private utils : UtilsService, private annStorage: AnnotationsStorageService) {}

  ngOnInit(): void {
    this.isGuest = this.authService.isGuest();
    if(this.file){
      if(!this.file?.url){
      this.fileService.getLinkTofile(this.file).subscribe(url => {
        this.file.url = url['URL'];
      });
    }
    }
    //ANGULARJS
    if(!(this.annotatorConfig instanceof AnnotatorConfig)){
      this.annotatorConfig = Object.assign(new AnnotatorConfig(), this.annotatorConfig);
    }
    //
    
    this.annotatorConfig.enable = !this.authService.isGuest() && this.file.entityType !== EntityType.COLLECTION;
    this.annotatorConfig.onNewAnnotation = this.newAnnotation;
    this.openCommentPanel = !this.annotatorConfig.canCloseCommentsPanel;
    this.showAnnotations = !this.utils.isTouchScreen();
    //this.showAnnotations =  !("false" == (new URLSearchParams(document.location.search)).get("annotations_support"));

    this.annStorage.getVisibility().pipe(skip(1)).subscribe(() => {
      this.tabScanner = true;
      setTimeout(() => this.tabScanner = false, 1500);
    });
  }
   
  applyTool(e){
    if(this.config[e.toolName] != undefined) this.updateFileConfig(e);
    else if(this[e.toolName]) this[e.toolName](e.value);
  }

  newAnnotation = (newAnn : Annotation) => {
    newAnn.page = this.config.page;
    newAnn.visibility = Visibility.PRIVATE;
  }
  
  afterFileLoaded(e){
    this.toolbar.update({totalPages : e.pages});
    this.busy = false;
    if(this.annotatorConfig.enable) this.initAnnotator();
  }

  initAnnotator(){
    if(!this.annotatorConfig.mainAnnotationConfig){
      this.annotatorConfig.mainAnnotationConfig = new AnnotationConfig(this.file.entityId, this.file['annEntityType'] || this.file.entityType);
    }

    this.annotatorConfig.fileId = this.file.amazonFileKey || 'BOLK';

    this.annotator.start();
  }
  
  commentPanel() { 
    this.openCommentPanel = !this.openCommentPanel;
    if(this.openCommentPanel && !this.containerService.get("shrinkCitationDetails")){
      this.toolbar.fullScreen();
    }
  }

  updateFileConfig = (e : any) => this.config[e.toolName] = e.value[e.toolName];
  search = (str : string) => this.pdfViewerComp.search(str);
  nextResult = () => this.pdfViewerComp.nextResult();
  searchResultsUpdated = (e) => this.toolbar.update({totalSearchResults : e});
  fullScreen = (e) => true;
  reloadAnnotations = (e) => this.annotator.loadPage(e.pageNumber, this.config.rotation);
  getTotalComment = () => this.annotator ? this.annStorage.getFilteredCommentsLength() : 0;
  hideAnnotations = (e) => this.hideFileAnnotations = e;
}
